
import { mapGetters } from 'vuex'
import Swiper from '~/components/swiper'
import ProductCard from '~/components/product-card/ProductCard'

export default {
  name: 'LoleRecentlyViewed',
  components: {
    Swiper,
    ProductCard,
  },
  props: {
    currentProduct: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    ...mapGetters({
      vxProducts: 'recentlyViewedProducts/getRecentlyViewedProducts',
      vxMetaData: 'common/getRecentlyViewed',
    }),
    products() {
      return this.vxProducts?.filter(
        (product) => product.id !== this.currentProduct?.id
      )
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.vxProducts.length > 0) this.addGAImpression()
    }, 2000)
  },
  methods: {
    productClick(product) {
      try {
        this.$gtmEvents.UAProductClick(product, {
          crossSell: true,
          url: this.$route.name.includes('index')
            ? 'homepage'
            : this.$route.fullPath,
        })
      } catch (error) {
        this.$sentryException(error, {
          source: 'store',
          level: 'warning',
          extra: 'Recently viewed - failed to log gtm event',
        })
      }
    },
    addGAImpression() {
      try {
        this.$gtmEvents.UAProductsImpression(this.vxProducts, {
          crossSell: true,
          url: this.$route.name.includes('index')
            ? 'homepage'
            : this.$route.fullPath,
        })
      } catch (error) {
        this.$sentryException(error, {
          source: 'store',
          level: 'warning',
          extra: 'Recently viewed - failed to log gtm event',
        })
      }
    },
  },
}
